import React from 'react';

import useDropdown from '../../../../hooks/useDropdown';
import classes from './styles.module.scss';

export default function DashboardDropdown({
  currentOption,
  setCurrentOption,
  options,
  placeholder,
  calendar,
  searchable,
}) {
  const dropdown = useDropdown({
    currentOption,
    setCurrentOption,
    options,
    classes,
    placeholder,
    calendar,
    searchable,
  });

  return <>{dropdown}</>;
}
